module.exports = __webpack_public_path__ + "static/media/discard-disabled.45a556ec.svg";